import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import TextField from '@mui/material/TextField';
import { useCallback, useState } from 'react';
import { createGiveJacksOutbound } from '../../api/outbound/commonOutbounds';
import { useInstanceId } from '../../context/instance/instanceContext';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { selectMyNumJacks } from '../../redux/reducers/selfDataReducer';
import { useAppSelector } from '../../redux/store';
import { FormControlContainer } from '../formControlContainer';
export const GiveJacksMessageBoxContents = ({ toPlayer, onClose }) => {
    const myNumJacks = useAppSelector(selectMyNumJacks);
    const instanceId = useInstanceId();
    const socketSend = useSocketSend();
    const [numJacksStr, setNumJacksStr] = useState('');
    const onChangeNumJacks = (event) => {
        setNumJacksStr(event.target.value);
    };
    const onClickGive = useCallback(() => {
        socketSend(createGiveJacksOutbound(toPlayer.name, numJacksStr, false));
        onClose();
    }, [numJacksStr, socketSend, toPlayer.name, onClose]);
    return (_jsxs(_Fragment, { children: [_jsxs(DialogContentText, { children: ["Enter the number of Jacks to give to ", toPlayer.name, ", or \"ALL\" to give all Jacks."] }), myNumJacks !== undefined && (_jsxs(DialogContentText, { children: ["You have ", myNumJacks.toLocaleString(), " Jack", myNumJacks !== 1 ? 's' : '', "."] })), _jsx(FormControlContainer, { children: _jsx(TextField, { id: `num-jacks-${instanceId}`, variant: 'filled', fullWidth: true, label: 'Number of Jacks', value: numJacksStr, onChange: onChangeNumJacks }) }), _jsx(DialogActions, { children: _jsx(Button, { variant: 'contained', color: 'secondary', onClick: onClickGive, children: "Give" }) })] }));
};
